const actionTypeIdentifier = 'F910B160-11D0-4C88-8D6E-22223333344411122232323213423'; // to be updated

//location form actions
export const resetWirelineChangeVendorForm = `RESET-WIRELINE-CHANGE-VENDOR-FORM-${actionTypeIdentifier}`;
export const setVendorOptions = `SET-WIRELINE-CHANGE-VENDOR-VENDOR-OPTIONS-${actionTypeIdentifier}`;
export const setAccountOptions = `SET-WIRELINE-CHANGE-VENDOR-ACCOUNT-OPTIONS-${actionTypeIdentifier}`;
export const setVendorDetails = `SET-WIRELINE-CHANGE-VENDOR-VENDOR-DETAILS-${actionTypeIdentifier}`;
export const setSubscriptionDetails = `SET-WIRELINE-CHANGE-VENDOR-SUBSCRIPTION-DETAILS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELINE-CHANGE-VENDOR-FORM-SUBMITTED-${actionTypeIdentifier}`;


export const wirelineChangeVendorModel = {
    circuitCode: ''
    , circuitId: 0
    , vendorDetailId: ''
    , financeAccountId: 0
    , wireLineApproverId: 0

    , localContactEmail: ''
    , localContactFullName: ''
    , localContactPhone: ''

    , altLocalContactEmail: ''
    , altLocalContactFullName: ''
    , altLocalContactPhone: ''

    , expediteRequest: false
    , needByDate: ''
    , businessJustification: ''
    , additionalInformation: ''
}
